<div class="calendar-backdrop">
  <div class="calendar-modal">
    <div class="calendar-header">
      <h3>Select Custom Range</h3>
      <button (click)="close.emit()">&times;</button>
    </div>

    <div class="calendar-body">
      <label>From:</label>
      <input type="date" [(ngModel)]="startDate" />

      <label>To:</label>
      <input type="date" [(ngModel)]="endDate" />
    </div>

    <div class="calendar-footer">
      <button (click)="submitRange()" [disabled]="!startDate || !endDate">Apply</button>
    </div>
  </div>
</div>